/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Zalify has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/* LOB product detail layout start */
(function () {
  function injectStyle() {
    if (document.getElementById('lob-product-detail-layout-style')) return;
    var style = document.createElement('style');
    style.id = 'lob-product-detail-layout-style';
    style.textContent = [
      '.shopify-section--main-product .product{align-items:flex-start}',
      '@media screen and (min-width:1000px){.shopify-section--main-product .product{column-gap:40px}.shopify-section--main-product .product__info{max-width:470px;margin-left:auto}}',
      '.shopify-section--main-product .product-form__buy-buttons{margin-top:18px}',
      '.shopify-section--main-product .product-form__add-button{min-height:54px;border-radius:0!important;background:#1f1f1f!important;color:#fff!important;border:1px solid #1f1f1f!important;font-size:15px;font-weight:500;letter-spacing:0;text-transform:none}',
      '.shopify-section--main-product .shopify-payment-button{margin-top:12px}',
      '.shopify-section--main-product .shopify-payment-button__button,.shopify-section--main-product .shopify-payment-button__button--unbranded,.shopify-section--main-product shopify-accelerated-checkout,.shopify-section--main-product shopify-buy-it-now-button{min-height:54px!important;border-radius:0!important;background:#efd7d1!important;color:#111!important;border:0!important;box-shadow:none!important;font-size:15px!important;font-weight:600!important;letter-spacing:0!important;text-transform:none!important}',
      '.lob-product-details-moved{margin-top:30px;border-top:1px solid #dedede}',
      '.lob-product-details-moved .product-tabs,.lob-product-details-moved .product-tabs__content,.lob-product-details-moved .product-tabs__tab-item-wrapper,.lob-product-details-moved .product-tabs__tab-item-content.rte{border:0;box-shadow:none;background:transparent}',
      '.lob-product-details-moved .product-tabs__tab-item-content.rte{color:#171717;font-size:15px;line-height:1.65}',
      '.lob-product-details-moved .product-tabs__tab-item-content.rte>div{max-width:none!important}',
      '.lob-product-details-moved .lob-description-heading{display:flex;align-items:center;justify-content:space-between;gap:16px;margin:0 0 22px!important;padding:28px 0 0;border-top:1px solid #dedede;font-size:20px!important;line-height:1.25;font-weight:700;letter-spacing:0}',
      '.lob-product-details-moved .lob-description-heading:after{content:"⌃";display:inline-block;flex:none;font-size:20px;font-weight:400;line-height:1}',
      '.lob-product-details-moved .lob-description-heading+.product-tabs__tab-item-content.rte,.lob-product-details-moved .lob-description-heading~.product-tabs__tab-item-content.rte:first-of-type{padding-bottom:28px;border-bottom:1px solid #dedede}',
      '.lob-product-details-moved .product-tabs__tab-item-content.rte section{margin:0!important;padding:28px 0!important;border-top:1px solid #dedede!important;border-bottom:0!important}',
      '.lob-product-details-moved .product-tabs__tab-item-content.rte h3{display:flex;align-items:center;justify-content:space-between;gap:16px;margin:0 0 18px!important;font-size:20px!important;line-height:1.25;font-weight:700;letter-spacing:0}',
      '.lob-product-details-moved .product-tabs__tab-item-content.rte h3:after{content:"⌃";display:inline-block;flex:none;height:auto;background:transparent;font-size:20px;font-weight:400;line-height:1}',
      '.lob-product-details-moved .product-tabs__tab-item-content.rte h3+ul{list-style:none;display:block;margin:0;padding:0}',
      '.lob-product-details-moved .product-tabs__tab-item-content.rte h3+ul li{position:relative;margin:0;padding:0 0 8px 22px;border:0;border-radius:0;background:transparent;font-size:15px;line-height:1.65}',
      '.lob-product-details-moved .product-tabs__tab-item-content.rte h3+ul li:before{content:"";position:absolute;left:4px;top:10px;width:4px;height:4px;background:#111}',
      '.lob-product-details-moved .product-tabs__tab-item-content.rte [style*="display:grid"][style*="grid-template-columns:150px"]{grid-template-columns:150px 1fr!important;gap:22px!important;padding:13px 0!important;border-top:1px solid #e7e7e7!important;font-size:15px;line-height:1.55}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function moveProductDetails() {
    injectStyle();
    var info = document.querySelector('.shopify-section--main-product .product__info');
    var form = document.querySelector('.shopify-section--main-product .product-form');
    var tabs = document.querySelector('.shopify-section--product-content .product-content__tabs');
    if (!info || !tabs || tabs.dataset.lobMoved === 'true') return;

    var host = document.querySelector('.lob-product-details-moved');
    if (!host) {
      host = document.createElement('div');
      host.className = 'lob-product-details-moved';
    }

    tabs.dataset.lobMoved = 'true';
    host.appendChild(tabs);
    var firstContent = host.querySelector('.product-tabs__tab-item-content.rte');
    if (firstContent && !host.querySelector('.lob-description-heading')) {
      var heading = document.createElement('h3');
      heading.className = 'lob-description-heading';
      heading.textContent = 'Description';
      firstContent.insertAdjacentElement('beforebegin', heading);
    }

    if (form && form.parentNode === info) {
      form.insertAdjacentElement('afterend', host);
    } else {
      info.appendChild(host);
    }

    var sourceSection = document.querySelector('.shopify-section--product-content');
    if (sourceSection) {
      sourceSection.style.display = 'none';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveProductDetails);
  } else {
    moveProductDetails();
  }
  document.addEventListener('shopify:section:load', moveProductDetails);
  setTimeout(moveProductDetails, 600);
  setTimeout(moveProductDetails, 1800);
})();
/* LOB product detail layout end */
